import React from 'react';
import { purchasesSubMenu } from './subMenus';
import TopNavPopup from './TopNavPopup';

const PurchasesPopup = () => {
  return <TopNavPopup name={'Purchases'} subMenu={purchasesSubMenu} />;
};

export default PurchasesPopup;
